/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:7045ce63-6b89-45af-abf7-33fb1504d45e",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_JtqJngT3Z",
    "aws_user_pools_web_client_id": "26glba23lj4tt9uan7c02ajp9g",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://zekxuwapazcynohaqei3c4ngki.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_appsync_apiKey": "da2-d6wrpairr5bc5l5ychbiq6oilq",
    "aws_cloud_logic_custom": [
        {
            "name": "appCommandApi",
            "endpoint": "https://fo5ajcgme2.execute-api.us-east-2.amazonaws.com/qa",
            "region": "us-east-2"
        }
    ]
};


export default awsmobile;
